import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { StyledQrCodeContainer } from './styled';

const QrCode = ({ url }: { url: string }) => {
  return (
    <StyledQrCodeContainer>
      <QRCodeSVG value={url} size={200} />
    </StyledQrCodeContainer>
  );
};

export default QrCode;
